import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar"
import HomePage from "./pages/HomePage";
import BrownBookPage from "./pages/BrownBookPage";
import RedBookPage from "./pages/RedBookPage";
import PurpleBookPage from "./pages/PurpleBookPage";
import LibraryPage from "./pages/LibraryPage";
import BoardPage from "./pages/BoardPage";

function App() {
  return (
    <Router>
      <div className="h-screen flex flex-col transition-all duration-300 ease-in-out overflow-hidden">
        <Navbar />
        <div className="flex-1 justify-items-center">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/oal" element={<BrownBookPage />} />
            <Route path="/showcase" element={<RedBookPage />} />
            <Route path="/condelia" element={<PurpleBookPage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/marmoris" element={<BoardPage />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
